module.exports = __webpack_public_path__ + "img/bulletin.7a7e332a.svg";